export default __webpack_public_path__ + "static/media/2_1.424726e4.png";